import axios from 'axios';
import { backendUrl } from 'config/envConfig';

const authClient = axios.create({
    baseURL: backendUrl,
    withCredentials: true,
});

export default authClient;